module.exports = __webpack_public_path__ + "static/img/lzy.55193a9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/classmates/lzy.png
// module id = PWn+
// module chunks = 42